import React from 'react';
import './Screen.css';

interface ScreenProps {
  children: React.ReactNode;
  className?: string;
}

export const Screen: React.FC<ScreenProps> = ({ children, className = '' }) => {
  return (
    <div className={`screen ${className}`}>
      <div className="screen-content">
        {children}
      </div>
    </div>
  );
};
